import { render, staticRenderFns } from "./PlainContent.vue?vue&type=template&id=2a79ec87&scoped=true"
import script from "./PlainContent.vue?vue&type=script&lang=js"
export * from "./PlainContent.vue?vue&type=script&lang=js"
import style0 from "./PlainContent.vue?vue&type=style&index=0&id=2a79ec87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79ec87",
  null
  
)

export default component.exports